module.exports = __webpack_public_path__ + "img/especial_premium.47394409.jpeg";